import { render, staticRenderFns } from "./TvStationEpgJsonDetail.vue?vue&type=template&id=3f823f17"
import script from "./TvStationEpgJsonDetail.vue?vue&type=script&lang=js"
export * from "./TvStationEpgJsonDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports